var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status==='landingpage')?_c('Landingpage'):(_vm.status==='paymentverify')?_c('PaymentVerify'):(_vm.status==='loading')?_c('Loader'):(_vm.status==='login')?_c('RegistrationPanel'):_c('Main')
}
var staticRenderFns = []

export { render, staticRenderFns }